import { resolveUTMAttribution, persistUTMAttribution } from './utmAttribution';

function initUniversalsUTMParser() {
    const attribution = resolveUTMAttribution();
    persistUTMAttribution(attribution);

    for (const [key, value] of Object.entries(attribution.values)) {
        $(`input[name="${key}"]`).val(value);
    }
}

initUniversalsUTMParser();